import { render, staticRenderFns } from "./meetings.vue?vue&type=template&id=07a51670&"
import script from "./meetings.vue?vue&type=script&lang=ts&setup=true&"
export * from "./meetings.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07a51670')) {
      api.createRecord('07a51670', component.options)
    } else {
      api.reload('07a51670', component.options)
    }
    module.hot.accept("./meetings.vue?vue&type=template&id=07a51670&", function () {
      api.rerender('07a51670', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/info/ethical-commission/meetings.vue"
export default component.exports